import { Component, Input, OnInit, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { CldSourceMediaSize } from './cld-picture.interface';
import { BreakpointsSize as bps } from '@fuse/services/match-media.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CldResizeDirective } from './cld.resize.directive';
@Component({
  selector: 'cld-picture',
  templateUrl: './cld-picture.component.html',
  styleUrls: ['./cld-picture.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    CldResizeDirective
  ]

})
export class CldPictureComponent implements OnInit {
  @Input()
  image: string;
  @Input()
  videoId: string;
  @Input()
  title: string;
  @Input()
  set sourceMediaSizes(v: CldSourceMediaSize[]) {
    this._sourceMediaSizes = v.sort((a, b) =>  bps.findIndex(s => s.bp === a.bp) - bps.findIndex(s => s.bp === b.bp)).reverse();
  };

  get sourceMediaSizes(): CldSourceMediaSize[] {
    return this._sourceMediaSizes;
  };

  private _sourceMediaSizes: CldSourceMediaSize[];
  @Input()
  lazyload: boolean = false;
  @Input()
  link: string;
  @Input()
  fallbackImage: string;
  @Input()
  round: boolean;

  @Input()
  routerLinkState: {[k: string]: any;} = null;

  constructor() { }

  ngOnInit() {

  }
}
